import axios, { AxiosInstance } from 'axios';

const apiFleet: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_FLEET_URL,
    headers: {
        'Content-type': 'application/json',
    },
});

export default apiFleet;
